/**
 * API base URL constants.
 *
 * - GATEWAY_URL: Routes through /api-gateway  (most services)
 * - DIRECT_URL:  Bypasses /api-gateway        (order-service, customer-service)
 */
const GATEWAY_URL = import.meta.env.VITE_API_ENDPOINT as string;
const DIRECT_URL = import.meta.env.VITE_API_DIRECT_URL as string;

export const API_BASE = {
  // ── Services that go through the API Gateway ──────────────────────────────
  GATEWAY: GATEWAY_URL,

  // ── Services that are called directly (no /api-gateway prefix) ────────────
  ORDER_ADMIN: `${DIRECT_URL}/order-service/api/private/admin`,
  ORDER_CUSTOMER: `${DIRECT_URL}/order-service/api/private/customer`,

  CUSTOMER_ADMIN: `${DIRECT_URL}/customer-service/api/private/admin`,
  CUSTOMER_CUSTOMER: `${DIRECT_URL}/customer-service/api/private/customer`,
  CUSTOMER_PUBLIC: `${DIRECT_URL}/customer-service/api/public`,
  CUSTOMER_INTERNAL: `${DIRECT_URL}/customer-service/api/private/internal`,
};
